(function () {
	'use strict';

    /*
     CancelOrderController
    -------------------------------------------------------------------------- */

	angular
		.module('PublicApp.Order.cancel', [])
		.controller('CancelMyOrderController', [
			'$scope',
			'__Form',
			'appServices',
			CancelMyOrderController
		]);

    /**
      * CancelMyOrderController for update order status
      *
      * @inject $scope
      * @inject __Form
      * @inject appServices
      * 
      * @return void
      *-------------------------------------------------------- */


	function CancelMyOrderController($scope, __Form, appServices) {

		var scope = this;
		scope = __Form.setup(scope, 'form_order_update', 'orderData');
		scope.ngDialogData = $scope.ngDialogData;
		scope = __Form.updateModel(scope, scope.orderData);


		/**
			  * process update order
			  *
			  * @return void
			  *---------------------------------------------------------------- */
		scope.cancel = function () {

			// post form data
			__Form.process({
				'apiURL': 'cart.order.cancel.process',
				'orderID': scope.ngDialogData.orderData._id
			}, scope).success(function (responseData) {

				appServices.processResponse(responseData, null, function (reactionCode) {

					$scope.closeThisDialog({ order_updated: true });

				});

			});

		};

		/**
			  * Close dialog and return promise object
			  *
			  * @return void
			  *---------------------------------------------------------------- */
		scope.closeDialog = function () {
			$scope.closeThisDialog();
		};

	};

})();